module.exports = __webpack_public_path__ + "media/site/images/products/saas_ceodash-screen2@2x-9f1a3bb3ad7c669ef48d242891227d50.png";